import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {Alert, Card, Container, Form, Image,} from 'react-bootstrap'; // Import Bootstrap components
import Logo from '../../assets/solutrak-logo.png';
import {useCookies} from 'react-cookie';
import '../auth/auth.css';
import './Login.css';
import {ReactiveBuilder} from "../../components/Loader/loader";
import axios from "axios";
import NetworkUtils from "../../../utils/NetworkUtils";
import ROUTES from "../../../utils/constants/endpoints";
import {useAuth} from "../../../context/AuthContext";

const Login = () => {
    const [username, setUsername] = useState('');
    const [loading, setLoading] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [cookies, setCookie] = useCookies();
    const { setIsAuthenticated } = useAuth();


    const handleForgotPassword = () => {
        navigate(ROUTES.FORGOT_PASSWORD, { replace: true });
    };

    const handleErrorDialogDismiss = () => {
        setError(null);
    }

    const handleLogin = async (username, password) => {
        setLoading(true);

        try {
            const response = await axios.post(
                "https://services.solucore.com/solutrak/api/accounts/signIn",
                { email: username, password: password },
                { headers: { "Content-Type": "application/json" } }
            );

            const data = response.data;
            const status = data.IsSuccess;
            const userInfo = data.Data;

            if (status) {
                // Define cookie options based on rememberMe
                let cookieOptions = { path: "/", sameSite: "none", secure: true };

                if (rememberMe) {
                    cookieOptions.maxAge = 30 * 24 * 60 * 60; // 30 days persistence
                }

                // Store user authentication data
                setCookie("isLoggedIn", true, cookieOptions); // ✅ Store as boolean
                setCookie("token", userInfo.token, cookieOptions);
                setCookie("userType", userInfo.role, cookieOptions);
                setCookie("defaultLat", userInfo.defaultLocationLatitude, cookieOptions);
                setCookie("defaultLng", userInfo.defaultLocationLongitute, cookieOptions);
                setCookie("firstName", userInfo.firstName, cookieOptions);
                setCookie("lastName", userInfo.lastName, cookieOptions);
                setCookie("phoneNumber", userInfo.phoneNumber, cookieOptions);
                setCookie("mobileNumber", userInfo.mobileNumber, cookieOptions);
                setCookie("profilePictureUrl", userInfo.profilePictureUrl, cookieOptions);
                setCookie("company", userInfo.company, cookieOptions);

                setIsAuthenticated(true); // ✅ Update React global auth state

                navigate(ROUTES.DASHBOARD, { replace: true });
            } else {
                setError("Invalid username or password");
                console.error("Login failed:", data.Message || "Unknown error");
            }
        } catch (error) {
            NetworkUtils.handleAxiosError(error, setError);
        } finally {
            setLoading(false);
        }
    };




    return (
        <Container fluid className="auth-container d-flex align-items-center justify-content-center">
            <Card className="auth-card vw-25 vh-50 px-0 py-0">
                <div className="logo-title-container d-flex justify-content-center pt-5">
                    <Image className="logo-big" src={Logo} alt="Logo"/>
                </div>
                <Card.Body className='mx-5'>
                    {error ? (<Alert variant="danger" dismissible={true} onClose={handleErrorDialogDismiss}>{error}</Alert>) : (
                        <h4 className="auth-title text-center mb-5 fw-light fs-4" style={{color: 'white'}}>
                            Login
                        </h4>
                    )}
                    <Form className="auth-form-container" onSubmit={(e) => {
                        e.preventDefault(); // Prevent default form submission
                        handleLogin(username, password);
                    }}>
                        <Form.Group className='my-2 w-100'>
                            <Form.Control
                                type="text"
                                id="username"
                                placeholder="Email"
                                className='auth-input py-1'
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group className='my-3 w-100'>
                            <Form.Control
                                type="password"
                                id="password"
                                placeholder="Password"
                                className='auth-input py-1'
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group className='my-2 w-100 checkbox-group'>
                            <Form.Check
                                type="checkbox"
                                label="Remember me next time"
                                id="rememberMe"
                                className='text-white text-start'
                                checked={rememberMe}
                                onChange={(e) => setRememberMe(e.target.checked)}
                            />
                        </Form.Group>
                        <ReactiveBuilder loading={loading}>
                            <div className="text-center my-2">
                                <button type="submit" className="auth-button">
                                    Login
                                </button>
                            </div>
                        </ReactiveBuilder>
                    </Form>
                </Card.Body>
                <Card.Footer className='text-primary w-100'>
                    <div onClick={handleForgotPassword} className="card-footer-text">
                        Forgot Password?
                    </div>
                </Card.Footer>
            </Card>
        </Container>
    );
};

export default Login;
